import '@ssml-editor/core';
import { MenuBaseService, EditorUtils } from '@ssml-editor/vue';
import { Alphabet } from '../../module/phoneme/alphabet.enum.js';
import { PHONEME_TYPE } from '../../module/phoneme/constant.js';
import { SAY_AS_TYPE } from '../../module/say-as/constant.js';
import '../../module/say-as/say-as-interpretation.enum.js';
import '@ssml-editor/modules';
import { SPEAK_TYPE } from '../../module/speak/constant.js';
import '../../module/speak/effect.enum.js';
import '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/create-editor-z7CFqjGE.js';
import { R as Range } from '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/index-B_A1dZu-.js';
import { SUB_TYPE } from '../../module/sub/constant.js';
import 'vue';
import 'element-plus';
/* empty css                                                                                                                                           */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                   */
/* empty css                                                     */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                     */
/* empty css                                                                                                                                              */
/* empty css                                                                                                                                               */
import { Warning } from '@ssml-editor/base';
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                                      */
/* empty css                                                                                                                                                */
/* empty css                      */
import 'cmu-pronouncing-dictionary';
/* empty css                          */
import '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/hotkeys-BEBL6MB3.js';
/* empty css                */
import '../say-as/constant.js';
/* empty css                        */
import '@element-plus/icons-vue';
/* empty css                                     */
import '../../../_virtual/lodash.js';
/* empty css                                                                                                                                             */
/* empty css                       */
/* empty css                         */
/* empty css                     */
/* empty css                                  */
/* empty css                             */
/* empty css                         */
import '../voice/voice-menu.vue.js';

class PinyinMenuService extends MenuBaseService {
  isDisabled() {
    if (super.isDisabled()) return true;
    const { selection } = this.editor;
    if (!selection) return true;
    if (Range.isCollapsed(selection)) {
      throw new Warning("请框选中文单词");
    }
    const value = this.getText();
    if (!/^[\u4E00-\u9FA5]+$/gi.test(value)) {
      throw new Warning("请框选中文单词");
    }
    const speakNode = EditorUtils.findSelectedNodeByType(
      this.editor,
      SPEAK_TYPE
    );
    if (!speakNode) {
      throw new Warning("请先为段落添加属性");
    }
    const subNode = EditorUtils.findSelectedNodeByType(this.editor, SUB_TYPE);
    if (subNode) {
      throw new Warning("已添加别名的文本无法添加拼音");
    }
    const sayAsNode = EditorUtils.findSelectedNodeByType(
      this.editor,
      SAY_AS_TYPE
    );
    if (sayAsNode) {
      throw new Warning("已添加读法的文本无法添加拼音");
    }
    return false;
  }
  setNode(ph, mark) {
    if (!this.isDisabled()) {
      const value = this.getText();
      if (value) {
        const element = {
          type: PHONEME_TYPE,
          alphabet: Alphabet.PY,
          ph,
          mark,
          children: [{ text: value }]
        };
        const node = EditorUtils.findSelectedNodeByType(
          this.editor,
          PHONEME_TYPE
        );
        if (node) {
          EditorUtils.removeSpace(this.editor, node);
          EditorUtils.unwrapAllByNode(this.editor, node);
        }
        this.editor.insertNode(element);
      }
    }
  }
}

export { PinyinMenuService };
//# sourceMappingURL=pinyin-menu-service.js.map
